export function parseP2pBuyAmount(amount: string): number | null {
	const trimmedAmount = amount.trim()
	if (!trimmedAmount) {
		return null
	}

	const parsedAmount = Number(trimmedAmount)
	if (!Number.isFinite(parsedAmount) || parsedAmount <= 0) {
		return null
	}

	return parsedAmount
}

export function isValidP2pBuyCurrencyCode(currencyCode: string | null | undefined): boolean {
	return Boolean(currencyCode?.trim())
}

export function isValidP2pBuyAmount(amount: string, currencyCode: string | null | undefined): boolean {
	if (!isValidP2pBuyCurrencyCode(currencyCode)) {
		return false
	}

	return parseP2pBuyAmount(amount) !== null
}
